import { render, staticRenderFns } from "./LeilaoParceiroCard.vue?vue&type=template&id=26d62f7d&scoped=true"
import script from "./LeilaoParceiroCard.vue?vue&type=script&lang=js"
export * from "./LeilaoParceiroCard.vue?vue&type=script&lang=js"
import style0 from "./LeilaoParceiroCard.vue?vue&type=style&index=0&id=26d62f7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d62f7d",
  null
  
)

export default component.exports